import React from "react";
import { useParams } from "react-router-dom";
import FormViewManager from "../../components/common/form/FormViewManager";
import TinyMCEpreview from "../../components/const/TinyMCEpreview";

export default function Progress_view() {
  const { id: projectId, dns } = useParams();
  console.log(dns)

  return (
    <FormViewManager
      params={{
        project: projectId,
        dns,
        module: "const",
        doc_type: "weekly",
      }}
      doc_name="주/월간 보고서"
    >
      <ProgressBody />
    </FormViewManager>
  );
}

/* ---------------------------------------------------------
📌 본문 컴포넌트 (이 파일 안에 포함됨!)
--------------------------------------------------------- */
function ProgressBody({ meta, data }) {
  if (!meta) return null;

  return (
    <div className="mt-6">

      {/* ===============================
          3) 상세 내용
      =============================== */}
      <section>
        <div className="border border-black text-sm">
          <div className="bg-gray-100 px-3 py-2 font-semibold border-b border-black text-body-bold">
            상세 내용
          </div>
          <div className="px-3 py-4 min-h-[150px]">
            <TinyMCEpreview
              html={meta.content || "<p>내용이 없습니다.</p>"}
            />
          </div>
        </div>
      </section>
    </div>
  );
}